import { FC } from 'react';
import { ChatbotProvided } from './chatbot-provided';
import { ChatbotProvider } from './chatbot-provider';

export const Chatbot: FC = () => {
    return (
        <ChatbotProvider>
            <ChatbotProvided />
        </ChatbotProvider>
    );
};
